export default __webpack_public_path__ + "static/media/contacts.8ca4fc3d.png";